import type { MarkdownTokenList } from '../../types';

const LINE_BREAK = /(<br\s*\/?>)/;

// Anything marked could read as more than text: inline syntax, autolinks
// (GFM links bare URLs and e-mail addresses), and what can open a block.
const MARKDOWN_SYNTAX = /[\\`*_[\]!<>~|#=\n\r]|:\/\/|www\.|@/;
const BLOCK_START = /^(?:\s{4}|\s*(?:[-+]\s|\d+[.)](?:\s|$)|-{3,}))/;

/**
 * The tokens lexMarkdown would give for text whose only markup is `<br>`, as
 * in titles like `Spots<br>2024`, built without the parser so they can be
 * made in the browser. Returns undefined for anything else, which needs the
 * real parser.
 */
export const plainTextTokens = (text: string): MarkdownTokenList | undefined => {
	const parts = text.split(LINE_BREAK).filter((part) => part !== '');
	const plain = parts.filter((part) => !LINE_BREAK.test(part));

	if (!text.trim() || text.startsWith('<') || BLOCK_START.test(text)) return undefined;
	if (plain.some((part) => MARKDOWN_SYNTAX.test(part))) return undefined;

	return [
		{
			type: 'paragraph',
			text,
			tokens: parts.map((part) =>
				LINE_BREAK.test(part)
					? { type: 'html', raw: part, inLink: false, inRawBlock: false, block: false, text: part }
					: { type: 'text', raw: part, text: part, escaped: false }
			)
		}
	] as MarkdownTokenList;
};
